import { render } from "./a-reset-size-button.vue?vue&type=template&id=d9409162&scoped=true"
import script from "./a-reset-size-button.vue?vue&type=script&lang=js"
export * from "./a-reset-size-button.vue?vue&type=script&lang=js"

import "./a-reset-size-button.vue?vue&type=style&index=0&id=d9409162&scoped=true&lang=sass"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9409162"]])

export default __exports__